<template>
  <div class="new-user">
    <img src="@/assets/images/svg/logo-short.svg" alt="logo" />
    <h1>{{ $t('terms.new.user.title') }}</h1>
    <p>{{ $t('terms.new.user.p1') }}</p>
    <p>
      <b>{{ $t('terms.new.user.bold') }}</b>
      {{ $t('terms.new.user.p2') }}
    </p>
    <p>
      {{ $t('terms.new.user.p3') }}
      <a
        :href="getLink({ name: 'StaticPage', params: { page: 'terms-conditions' } })"
        target="_blank"
      >
        {{ $t('terms.new.user.bold') }}
      </a>
      {{ $t('and') }}
      <a :href="getLink({ name: 'StaticPage', params: { page: 'privacy' } })" target="_blank">{{
        $t('terms.new.user.link.policy')
      }}</a
      >.
    </p>
    <Checkbox
      :value="subscribeToMarketingEmail"
      :label="$t('terms.subscribeCheckboxLabel')"
      :on-change="v => (subscribeToMarketingEmail = v)"
    />
    <div class="buttons">
      <Button :text="$t('accept')" :on-click="() => accept({ subscribeToMarketingEmail })" />
      <Button :text="$t('button.decline')" :on-click="onDecline" style-type="secondary" />
    </div>
  </div>
</template>

<script>
import { Button, Checkbox } from '@bookis/web-components'

export default {
  name: 'NewUser',
  components: {
    Button,
    Checkbox
  },
  props: {
    changeStep: {
      type: Function,
      required: true
    },
    accept: {
      type: Function,
      required: true
    },
    goToLink: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      subscribeToMarketingEmail: false
    }
  },
  methods: {
    onDecline() {
      this.changeStep(2)
    },
    getLink(route) {
      return this.$router.resolve(route).href
    }
  }
}
</script>

<style lang="scss" scoped>
.new-user {
  img {
    display: block;
    margin: 0 auto 10px;
  }
  .checkbox {
    border-bottom: none;
    padding: 0;
    &::v-deep {
      .checkbox-label {
        font-size: 14px;
      }
    }
  }
}
</style>
